import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/Home.vue'



const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta:{
      title: "Brand4",
      hasToolbar: true,
      hasFooter: true,      
      requiresAuth: true,
      exitOnBack: true,
      statusColor: '#1aa57a',
      keepAlive: false,
      transition: 'slide-left',
    }
  },
  {
    path: '/subs',
    name: 'subs',
    component:  () => import(/* webpackChunkName: "subs" */ '../views/Subs.vue'),
    meta:{
      title: "Subscriptions",
      hasToolbar: true,
      hasFooter: true,      
      requiresAuth: true,
      exitOnBack: true,
      statusColor: '#1aa57a',
      keepAlive: false,
      transition: 'slide-left',
    }
  },
  {
    path: '/playlist',
    name: 'playlist',
    component:  () => import(/* webpackChunkName: "playlist" */ '../views/PlayList.vue'),
    meta:{
      title: "My Library",
      hasToolbar: true,
      hasFooter: true,      
      requiresAuth: true,
      exitOnBack: true,
      statusColor: '#1aa57a',
      keepAlive: false,
      transition: 'slide-left',
    }
  },
  {
    path: '/search',
    name: 'search',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Search.vue'),
    meta:{
      transition: 'slide-left',
      keepAlive: false,
      hasToolbar: false,
      hasFooter: false, 
    }
  },
  {
    path: '/watch',
    name: 'watch',
    component: () => import('../views/Watch.vue'),
    meta:{
      hasToolbar: true,
      requiresAuth: true,
      transition: 'slide-left',
      statusColor: '#0e1416',
      keepAlive: false,
    }
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    meta:{
      transition: 'slide-left',
      keepAlive: false
    }
  },
  {
    path: '/cube',
    name: 'cube',
    component: () => import('../views/Cube.vue'),
    meta:{
      hasToolbar: true,
      requiresAuth: true,
      transition: 'fade',
      statusColor: '#0e1416'
    }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
